import { YStack } from '@shinetools/lumen-react'

import type { WithTrackingContext } from '../../../../../../../../../../../../types/withTrackingContext'
import { AdditionalContact } from '../AdditionalContact'
import { AutomationSection } from '../AutomationSection'
import { CompanyCountry } from './elements/CompanyCountry'
import { CompanyName } from './elements/CompanyName'
import { CompanyPhone } from './elements/CompanyPhone'
import { CompanyVatNo } from './elements/CompanyVatNo'

export const ManageCompany = ({ trackingContext }: WithTrackingContext) => (
  <YStack gap={32}>
    <YStack gap={24}>
      <CompanyName />
      <CompanyCountry />
      <CompanyVatNo />
      <CompanyPhone />
    </YStack>
    <AdditionalContact />
    <AutomationSection trackingContext={trackingContext} />
  </YStack>
)
